<template>
  <div>
    <Step2a v-if="getRole === '' && getCountry.id === 'ES'"> </Step2a>
    <Step2b v-else> </Step2b>
  </div>
</template>

<script>
import Step2a from '@/components/Register/Step2a.vue'
import Step2b from '@/components/Register/Step2b.vue'
export default {
  name:'RegisterStep2',
  components: {
    Step2a,
    Step2b
  },
  computed: {
    getRole() {
      return this.$store.state.register.role
    },
    getCountry() {
      return this.$store.state.register.country
    }
  }
}
</script>

<style lang="scss" scoped></style>
